export default (raw, allowedKeys, isJson = false) =>
  Object.keys(raw)
    .filter((key) => allowedKeys.includes(key))
    .reduce(
      (obj, key) => ({
        ...obj,
        [key]: isJson ? JSON.parse(raw[key]) : raw[key],
      }),
      {}
    )
